<template>
  <div id="app">
    <page-header
      :is-transparent="currentIsTransparent"
      :is-no-shadow="currentIsNoShadow"
    ></page-header>

    <div class="main-container" ref="backTop">
      <transition name="el-fade-in-linear">
        <router-view />
      </transition>
    </div>

    <apj-tool></apj-tool>
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHeader from "./components/page-header/page-header.vue";
import PageFooter from "./components/page-footer/page-footer.vue";
import ApjTool from "./components/apj-tool/apj-tool.vue";

export default {
  name: "App",
  components: {
    PageHeader,
    PageFooter,
    ApjTool,
  },
  data() {
    return {
      oldIsTransparent: false,
      currentIsTransparent: false,
      oldIsNoShadow: false,
      currentIsNoShadow: false,
    };
  },
  created() {
    let that = this;
    globalEvent.$on("changeHeaderTransparent", (res) => {
      that.oldIsTransparent = (res && res.isTransparent) || false;
      that.currentIsTransparent = (res && res.isTransparent) || false;
      that.oldIsNoShadow = (res && res.isNoShadow) || false;
      that.currentIsNoShadow = (res && res.isNoShadow) || false;
      that.handleScroll();
    });

    // globalEvent.$on('pageLoad', (res) => {
    //   that.handleScroll()
    // })

    window.addEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    const w = document.body.clientWidth;
    const h = document.body.clientHeight;
    console.log(w, h);
  },
  methods: {
    openUrl(url) {
      this.$router.push(url);
    },
    handleScroll() {
      let that = this;
      if (window.pageYOffset > 100) {
        that.currentIsTransparent = false;
        that.currentIsNoShadow = false;
      } else {
        that.currentIsTransparent = that.oldIsTransparent;
        that.currentIsNoShadow = that.oldIsNoShadow;
      }
      // console.log('滚动高度', window.pageYOffset)
    },
  },
  destroyed() {
    globalEvent.$off("changeHeaderTransparent");
  },
};
</script>

<style lang="scss">
@import "@sadais/piui-console/scss/index.scss";
@import "animate.css";
@import url("https://at.alicdn.com/t/font_2425752_dpji99c2o4t.css");
@import "./assets/theme.scss";

$test-color: blue;
.hide {
  opacity: 0;
}

/** replace element ui style */
.el-carousel__button {
  height: 10px;
  width: 10px;
  background-color: $color-bg-primary !important;
}

.el-carousel__indicator.is-active button {
  width: 30px;
}

// .el-carousel__indicators--horizontal {
// padding-bottom: 50px;
// }

/** page css */

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  // margin-top: 60px;
  // min-width: 1400px;
}

// html, body, div, p, table, tr, th, td, a {
//   margin: 0;
//   padding: 0;
// }

* {
  margin: 0;
  padding: 0;
  text-decoration: unset;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 30px;
  color: #222;
  font-family: PingFang SC;
  text-size-adjust:none;
  -webkit-text-size-adjust: none;
  // font-family: "PingFang SC,Helvetica Neue,Helvetica,Hiragino Sans GB,Microsoft YaHei,Noto Sans CJK SC,WenQuanYi Micro Hei,Arial,sans-serif";
}
*::-webkit-scrollbar { width: 0 !important }
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  width: 100%;
  min-height: 800px;
}

.container {
  width: 100%;
  padding: 0 160px;
}

.full-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// @media screen and (max-width: 1279px) {
//   #app {
//     min-width: 1024px;
//   }
//   html, body, div, p, table, tr, th, td, a {
//     margin: 0;
//     padding: 0;
//   }

//   * {
//     font-size: 14px;
//   }
//   .container {
//     padding: 0 80px;
//   }
// }

// @media screen and (max-width: 1440px) and (min-width: 1280px) {
//   #app {
//     min-width: 1024px;
//   }
//   .container {
//     padding: 0 80px;
//   }
// }

// @media screen and (max-width: 1680px) and (min-width: 1440px) {
//   #app {
//     min-width: 1200px;
//   }

//   .container {
//     padding: 0 100px;
//   }

// }
</style>



// WEBPACK FOOTER //
// src/App.vue